export const COMMITTEE_PHOTO_MAP = {
  "Cr. Bolhasan Bin Haji Putit": "/team/president.jpg",
  "Eddy Anak Jaruh": "/team/naib-presiden.jpg",
  "Mohamad Affendi Bin Medali": "/team/timbalan-presiden.jpg",
  "Zorimie Bin Juhaili": "/team/setiausaha.jpg",
  "Kelvin Anak Geripin": "/team/timbalan-setiausaha.jpg",
  "Nurliyana Binti Shafie": "/team/bendahari.jpg",
};
